import { ControlledSelectField } from 'components/Form';
import type { WorkOrderChangeSeasonData } from 'gql/graphql';

import type React from 'react';
import { useEffect, useMemo } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import type { Control, UseFormClearErrors, UseFormSetError } from 'react-hook-form/dist/types/form';

import Style from './SeasonSelectForm.module.css';

interface ISeasonsSelectForm {
    control: Control;
    seasonFrom?: any;
    seasonTo?: any;
    setError: UseFormSetError<any>;
    clearErrors: UseFormClearErrors<any>;
    setValue: UseFormSetValue<any>;
    workOrderChangeSeasons: WorkOrderChangeSeasonData[];
}

export const SeasonsSelectForm: React.FC<ISeasonsSelectForm> = (props) => {
    const { control, seasonFrom, seasonTo, setError, clearErrors, setValue, workOrderChangeSeasons } = props;

    const seasonsItems = useMemo(
        () =>
            workOrderChangeSeasons.map((i) => ({
                id: i.id,
                label: i.year,
            })) || [],
        [workOrderChangeSeasons],
    );

    const seasonToItems = useMemo(
        () => (!seasonFrom?.id ? [] : seasonsItems.filter((i) => i.id !== seasonFrom?.id)),
        [seasonFrom?.id, seasonsItems],
    );

    useEffect(() => {
        if (!seasonFrom?.id || !seasonTo?.id) {
            setError('season', { message: 'required' });
        } else {
            if (seasonFrom?.id === seasonTo?.id) {
                setValue('seasonTo', undefined);
            }

            clearErrors('season');
        }
    }, [clearErrors, seasonFrom, seasonTo, setError, setValue]);

    return (
        <div className={Style.seasonsSelectForm}>
            <div className="season-select-block">
                <div>Перенос с сезона</div>
                <ControlledSelectField
                    name="seasonFrom"
                    control={control}
                    items={seasonsItems}
                    dropdownClassName={Style.widthTooltip}
                />
            </div>
            <div className="season-select-block">
                <div>Добавление в сезон</div>
                <ControlledSelectField
                    name="seasonTo"
                    control={control}
                    items={seasonToItems}
                    dropdownClassName={Style.widthTooltip}
                />
            </div>
        </div>
    );
};

SeasonsSelectForm.displayName = 'SeasonsSelectForm';
